<template>
  <div class="mb-6">
    <h2 id="cover_funeral_expenses" class="text-h2">
      {{ $t('L_cover_funeral') }}
    </h2>
    <v-row class="d-flex align-center">
      <v-col cols="12" sm="8" md="9" id="cover_funeral_expenses" class="pt-4 pb-0">
        <h4 class="text-h4">
          {{ $t('L_how_much_funeral') }}
        </h4>
      </v-col>
      <v-col cols="12" class="pl-1 pb-0">
        <LinkedSlider
          v-model="amount"
          :form-input="formInput"
          :max="20000"
          :step="200"
          :tooltip-text="$t('L_average_cost_burial')"
          @update:model-value="$emit('update:modelValue', $event)"
          @input="$emit('input', $event)"
          label-id="cover_funeral_expenses"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import Slider from '@/components/Inputs/Slider/Slider.vue';
import LinkedSlider from './LinkedSlider.vue';
import CurrencyDisplay from './CurrencyDisplay.vue';

const componentOptions: ComponentOptions = {
  name: 'CoverFuneralExpenses',
  components: {
    LinkedSlider,
    Slider,
    CurrencyDisplay,
  },
  data: () => ({
    amount: 8000,
    manualInput: false,
  }),
  props: {
    modelValue: {
      type: [Number, String],
      required: true,
    },
    formInput: {
      type: Object,
      required: true,
    },
  },
  watch: {
    modelValue(value) {
      this.amount = value;
    },
  },
  mounted() {
    this.amount = this.modelValue;
  },
};

export default defineComponent(componentOptions);
</script>
